import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/home/Hero";
import { HowItWorks } from "@/components/home/HowItWorks";
import { ToolsBento } from "@/components/home/ToolsBento";
import { Pricing, Story, FinalCta } from "@/components/home/Sections";
import { Marquee } from "@/components/site/Marquee";
import { scrollToId } from "@/components/site/SmoothScroll";
import { usePageTitle } from "@/hooks/useMimis";

export default function Home() {
  const { hash } = useLocation();
  usePageTitle("MIMIS | Piattaforma SaaS Amichevole Italiana");

  useEffect(() => {
    if (!hash || hash.includes("session_id")) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 150);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <HowItWorks />
      <ToolsBento />
      <Story />
      <Pricing />
      <div className="bg-[#F5F5F7]"><FinalCta /></div>
    </main>
  );
}
